module.exports = __webpack_public_path__ + "static/media/heart.fab68a80.svg";